import {
  ConsignmentTabFields,
  HeaderTabFields,
  NamesAndPartiesTabFields,
  supportInfoMessage,
} from '../types/fieldEnums';
import { FieldPrefix } from '../constants/fieldPrefixes';

export function fieldNameConverter(field: string) {
  let fieldName = field;

  if (
    Object.keys(HeaderTabFields).includes(fieldName) ||
    Object.keys(NamesAndPartiesTabFields).includes(fieldName) ||
    Object.keys(ConsignmentTabFields).includes(fieldName) ||
    fieldName === supportInfoMessage
  ) {
    fieldName = FieldPrefix.lpco + fieldName;
  }

  return fieldName;
}
